import React, { useEffect } from 'react';

import SearchTabsContainer from 'components/SearchTabsContainer';

const SearchPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <SearchTabsContainer pageType="search" />;
};

export default SearchPage;



// WEBPACK FOOTER //
// ./src/pages/SearchPage/SearchPage.js